<template>
    <div class="orders_filters_tabs">
      <simplebar>
        <div class="content-sm">
          <ul class="tabs-nav">
            <li>
              <button data-tab="filter-online" class="btn tab-toggle" :class="{ active: filter.includes('online') }"
                      @click="setFilter('online')">
                Main ecomm
              </button>
            </li>
            <li>
              <button data-tab="filter-online" class="btn tab-toggle" :class="{ active: filter.includes('online_eu') }"
                      @click="setFilter('online_eu')">
                EU ecomm
              </button>
            </li>
            <li>
              <button data-tab="filter-new_york" class="btn tab-toggle" :class="{ active: filter.includes('new_york') }"
                      @click="setFilter('new_york')">
                Mulberry
              </button>
            </li>
            <li>
              <button data-tab="filter-london" class="btn tab-toggle" :class="{ active: filter.includes('london') }"
                      @click="setFilter('london')">
                London
              </button>
            </li>
            <li>
              <button data-tab="filter-seeding" class="btn tab-toggle" :class="{ active: filter.includes('seeding') }"
                      @click="setFilter('seeding')">
                Seeding
              </button>
            </li>
            <li>
              <button data-tab="filter-sonny" class="btn tab-toggle" :class="{ active: filter.includes('sonny') }"
                      @click="setFilter('sonny')">
                Masaryk
              </button>
            </li>

          </ul>
        </div>
      </simplebar>
    </div>
  <table class="table" :class="{sortable: sortable}">
    <thead>
    <tr>
      <th @click="sortBy('created_at')" :class="{active: sortKey === 'created_at'}" class="col__created_at"><span>Or. date
        <span v-if="sortKey === 'created_at'" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
      <th @click="sortBy('source')" :class="{active: sortKey === 'source'}" class="col__source">
        <span>Source<span v-if="sortKey === 'source'" class="icon icon--down" :class="{'icon--up': !reverse}"/></span>
      </th>
      <th @click="sortBy('value')" :class="{active: sortKey === 'value'}" class="col__value"><span>Tot. value
        <span v-if="sortKey === 'value'" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
      <th @click="sortBy('order_number')" :class="{active: sortKey === 'order_number'}"><span>Order no.
        <span v-if="sortKey === 'order_number'" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
      <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
          :class="{active: sortKey === column.name}"><span>{{ column.label }}
        <span v-if="sortKey === column.name" class="icon icon--down" :class="{'icon--up': !reverse}"/></span></th>
    </tr>
    </thead>
    <tbody v-if="rows.length > 0" class="table__body">
    <tr v-for="row in rows" :class="{ expired: row.expired }" :key="row.id" @click="handleRowClick(row, $event)">
      <td>
        <div class="col__created_at">
          <div v-html="formatDate(row.created_at)"></div>
        </div>
      </td>
      <td>
        <div class="col__source">
          <div v-html="row.source"></div>
        </div>
      </td>
      <td>
        <div class="col__price">
          {{ `${Intl.NumberFormat('en-us', { style: 'currency', currency: `${row.currency}` }).format(row.value)}` }}
        </div>
      </td>
      <td>
        <div class="col__number">
          {{ row.order_number || '?' }}
        </div>
      </td>
      <td v-for="field in fields" :key="field.name" :class="field.classNames && field.classNames(row)">
        <div v-html="formatField(row, field)"></div>
      </td>
    </tr>
    </tbody>
    <tbody v-if="rows.length === 0 && requestCompleted">
    <tr>
      <td colspan="3">
        <div class="col-no-results">{{ noData }}</div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment'
import simplebar from '../components/simplebar.vue';
import 'simplebar/dist/simplebar.min.css';

export default {
  name: 'OrdersTable',
  components: { simplebar },
  emits: ['rowClick', 'updateSort'],
  props: {
    rows: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return []
      }
    },
    requestCompleted: {
      type: Boolean,
      default: true
    },
    sortable: {
      type: Boolean,
      default: false
    },
    noData: {
      type: String,
      default: "No data found!"
    }
  },
  data() {
    return {
      filter: [],
      sortKey: 'created_at',
      reverse: true,
    }
  },
  methods: {
    formatDate: (timestamp) => {
      return moment(timestamp).format('MMMM D, YYYY')
    },
    setFilter(filter) {
      if(this.filter.includes(filter)) {
        this.filter = this.filter.filter(e => e !== filter)
      } else {
        this.filter = this.filter.concat(filter);
      }

      this.$emit('updateSort', this.sortKey, this.reverse ? 'desc' : 'asc', this.filter);
    },
    formatField(row, field) {
      if (!field.format) {
        return row[field.name];
      }

      return field.format(row);
    },
    handleRowClick(row, event) {
      if (row.source === "Seeding") {
        if (event.target.tagName === 'A') {
          return;
        }
        this.$emit('rowClick', row);
      }
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;

      this.sortKey = sortKey;
      this.$emit('updateSort', sortKey, this.reverse ? 'desc' : 'asc', this.filter);
    },
  }
}
</script>

<style scoped>

.col__created_at {
  width: 150px !important;
}

.orders_filters_tabs {
  margin-bottom: 30px;
}

.tab-toggle {
  background: #FFF;
  color: black;
}

.table__body tr:hover {
  background-color: #E5E5E5;;
  cursor: pointer;
}

.table th:first-child {
  width: 50px;
}

.icon--down {
  position: absolute;
  width: 11px;
  height: 6px;
  right: -14px;
  top: 2px;
  background-position: bottom center;
}

.icon--up {
  transform: rotate(180deg);
}

th > span {
  position: relative;
}

.sortable th.active {
  text-decoration: underline;
}

.sortable th:hover {
  cursor: pointer;
}

table:not(.sortable) .icon {
  display: none;
}

</style>

